import { EnvironmentConfigPort } from '../../ports'
import { Stage } from '../../model/stage'
import { EnvironmentConfig } from '../../model/environment-config'

export const environmentConfigAdapter: EnvironmentConfigPort = () => {
  let stage: Stage
  if (window.location.hostname.match(/^(www\.)?otto\.de$/)) {
    stage = 'live'
  } else {
    stage = 'nonlive'
  }

  return {
    stage,
  } as EnvironmentConfig
}
